import React, { useContext } from "react";
import AppApi from "./apis/AppApi";
import AppStore from "./stores/Store";

interface AppContextType {
  store: AppStore;
  api: AppApi;
}

const AppContext = React.createContext<null | AppContextType>(null);

export const useAppContext = () => {
  const context = useContext(AppContext);
  return context as AppContextType;
};

export default AppContext;
